import { ComingSoonPanel, IconAddon } from '@shared/ui';

/**
 * Which products this museum has, and what they cost it.
 *
 * The client-side half of the catalog's Products tab — the other end of the
 * same relationship. Was called "Product settings" while `/addons` was still
 * the catalog's word; both now say Products, because one concept wearing two
 * names is how Sales and Ops end up describing different things to each other.
 *
 * Building it before the catalog exists would mean inventing the products it is
 * supposed to read.
 */
export function ClientProductsTab() {
    return (
        <ComingSoonPanel
            icon={<IconAddon className="size-6" />}
            title="Products"
            blurb="One card per product from the catalog, scoped to this museum: whether it is active, which components it brings, and what it costs. It lands with the catalog and the per-tenant activations it reads."
        />
    );
}
